<!-- <div class="controls">
    <button (click)="startSimulation()" [disabled]="isSimulationActive">Start Simulation</button>
    <button (click)="pauseSimulation()" [disabled]="!isSimulationActive">Pause</button>
    <button (click)="resetSimulation()" [disabled]="!isSimulationActive">Reset</button>
    <button (click)="toggleSimulationMode()">Toggle Simulation Mode</button>
    <button (click)="zoomIn()">Zoom In</button>
    <button (click)="zoomOut()">Zoom Out</button>
    <button (click)="fitToScreen()">Fit Screen</button>
</div> -->
<div class="diagram-wrapper">
    <div #diagramContainer class="diagram-container"></div>
    <div class="legend-container" *ngIf="showLegend && legendItems.length > 0">
        <div class="legend-header">
            <h4>{{ legendTitle }}</h4>
        </div>
        <div class="legend-items">
            <div class="legend-item" *ngFor="let item of legendItems">
            <div class="legend-color" [style.background-color]="item.color"></div>
            <span>{{ item.label }}</span>
            </div>
        </div>
    </div>
    <!-- Recuadro vacío para ocultar marca de agua cuando la leyenda no está activa -->
    <div class="watermark-overlay" *ngIf="!showLegend && hideWatermark"></div>
</div>  